import { IIconProps } from 'src/interfaces/IconProps';

const ReloadIcon = ({ width = 16, height = 16, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M.5 0a.5.5 0 0 1 .5.5v3.071C2.42 1.262 5.022 0 7.938 0 12.387 0 16 3.578 16 8c0 4.422-3.614 8-8.062 8a8.072 8.072 0 0 1-6.717-3.574.5.5 0 0 1 .83-.557A7.072 7.072 0 0 0 7.938 15C11.842 15 15 11.862 15 8s-3.158-7-7.062-7c-2.972 0-5.455 1.44-6.51 3.915A.503.503 0 0 1 1.383 5H5.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5v-5A.5.5 0 0 1 .5 0Z'
      fill={color}
    />
  </svg>
);

export default ReloadIcon;
